export const SBER_PRIME_VERSIONS = {
    "6ac9117b55e3e2aa051e8b28": "v2",
    "6ac9117b55e3e2aa051e8b28_v2": "v2",
    "6ac9125555e3e2aa051e8d1a": "v3",
    "6ac9125555e3e2aa051e8d1a_v2": "v3",
};

export const isLightOffer = (offer) => Array.isArray(offer?.offerOptions) && offer.offerOptions.includes("light") && !SBER_PRIME_VERSIONS[offer?._id];
export const getLightOfferCover = (offer, cover, mobile = false) => cover || (isLightOffer(offer) ? `https://storage.yandexcloud.net/ris-email/1yearSberlogo${mobile ? "Mobile" : ""}.png` : "");

export const getOfferType = (offer) => {
    const options = Array.isArray(offer?.offerOptions) ? offer.offerOptions : [];
    return options.includes("special") ? "special" : options.find((option) => !["isEndDate", "redirect", "light"].includes(option)) || false;
};
